import React from 'react';

import { Button } from '@/new/components/shadcn/button';

export type FilterModalContentProps = {
  onClear: () => void;
  children: React.ReactNode;
  className?: string;
};

export function FilterModalContent({ onClear, children, className = '' }: FilterModalContentProps) {
  return (
    <div className={className}>
      <div className="space-y-5">{children}</div>
      {/* Actions */}
      <div className="mt-8 flex border-t border-gray-200 pt-4">
        <Button variant="destructive" onClick={onClear} className="flex-1">
          Clear
        </Button>
      </div>
    </div>
  );
}
